import type { ReactElement, SVGProps } from "react";

type IconName =
  | "arrow-right"
  | "check-read"
  | "pulse"
  | "shield-warning"
  | "dna"
  | "graph-up"
  | "chart-square"
  | "database"
  | "lock-password"
  | "server-square"
  | "routing-2"
  | "layers"
  | "users"
  | "signal-off"
  | "trending-up"
  | "trending-down"
  | "clock"
  | "file-check"
  | "history";

const PATHS: Record<IconName, ReactElement> = {
  "arrow-right": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 12h16" />
      <path d="M14 6l6 6-6 6" />
    </g>
  ),
  "check-read": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12.5l4 4 8-10" />
      <path d="M10 16.5l1 1 10-12" />
    </g>
  ),
  pulse: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12h4l2-5 4 10 2-5 2 2h6" />
    </g>
  ),
  "shield-warning": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2L4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z" />
      <path d="M12 8v4" />
      <circle cx="12" cy="15" r="0.8" fill="currentColor" />
    </g>
  ),
  dna: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 3c0 4 12 5 12 9s-12 5-12 9" />
      <path d="M18 3c0 4-12 5-12 9s12 5 12 9" />
      <path d="M7.5 7h9M7.5 17h9M8.5 10h7M8.5 14h7" />
    </g>
  ),
  "graph-up": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3v18h18" />
      <path d="M7 15l4-4 3 3 6-7" />
      <path d="M15 7h5v5" />
    </g>
  ),
  "chart-square": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M8 16v-4" />
      <path d="M12 16V8" />
      <path d="M16 16v-6" />
    </g>
  ),
  database: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx="12" cy="5" rx="8" ry="2.5" />
      <path d="M4 5v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5V5" />
      <path d="M4 11v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-6" />
    </g>
  ),
  "lock-password": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M7.5 10V7a4.5 4.5 0 0 1 9 0v3" />
      <circle cx="9" cy="15.5" r="0.75" fill="currentColor" />
      <circle cx="12" cy="15.5" r="0.75" fill="currentColor" />
      <circle cx="15" cy="15.5" r="0.75" fill="currentColor" />
    </g>
  ),
  "server-square": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="8" rx="2" />
      <rect x="3" y="13" width="18" height="8" rx="2" />
      <circle cx="7" cy="7" r="0.8" fill="currentColor" />
      <circle cx="7" cy="17" r="0.8" fill="currentColor" />
      <path d="M11 7h6M11 17h6" />
    </g>
  ),
  "routing-2": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="5" cy="5" r="2" />
      <circle cx="19" cy="5" r="2" />
      <circle cx="12" cy="19" r="2" />
      <path d="M7 5h10" />
      <path d="M6.5 6.5l5 11" />
      <path d="M17.5 6.5l-5 11" />
    </g>
  ),
  layers: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 3l9 5-9 5-9-5 9-5z" />
      <path d="M3 13l9 5 9-5" />
      <path d="M3 18l9 5 9-5" />
    </g>
  ),
  users: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="8" r="3.5" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <circle cx="17" cy="7" r="2.5" />
      <path d="M15 14c3 0 6 2 6 5" />
    </g>
  ),
  "signal-off": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 8.5a14 14 0 0 1 5.5-3" />
      <path d="M5 12a9 9 0 0 1 2.5-1.7" />
      <path d="M16.5 5.5a14 14 0 0 1 5.5 3" />
      <path d="M16.5 10.3a9 9 0 0 1 2.5 1.7" />
      <circle cx="12" cy="17" r="1.2" fill="currentColor" />
      <path d="M4 4l16 16" />
    </g>
  ),
  "trending-up": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M14 7h7v7" />
    </g>
  ),
  "trending-down": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 7l6 6 4-4 8 8" />
      <path d="M14 17h7v-7" />
    </g>
  ),
  clock: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </g>
  ),
  "file-check": (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <path d="M14 3v6h6" />
      <path d="M9 14l2 2 4-4" />
    </g>
  ),
  history: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4v5h5" />
      <path d="M12 8v5l3 2" />
    </g>
  ),
};

type IconProps = {
  name: IconName;
  size?: number;
} & Omit<SVGProps<SVGSVGElement>, "name">;

export function LandingIcon({ name, size = 16, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}

export type { IconName };
